module.exports = __webpack_public_path__ + "img/LV40103163202.687c1e3d.png";